/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Count_OneInputs */

const en_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 file(s)`)
};

const fr_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 fichier`)
};

const de_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Datei(en)`)
};

const it_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 file(i)`)
};

const ru_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 файл(а)`)
};

const es_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 archivo(s)`)
};

const zh_cn2_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 个文件`)
};

const ja_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ファイル`)
};

const hi_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 फ़ाइल`)
};

const pt_pt2_file_count_one = /** @type {(inputs: File_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 arquivo(s)`)
};

/**
* | output |
* | --- |
* | "1 file(s)" |
*
* @param {File_Count_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_count_one = /** @type {((inputs?: File_Count_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Count_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_count_one(inputs)
	if (locale === "de") return de_file_count_one(inputs)
	if (locale === "it") return it_file_count_one(inputs)
	if (locale === "ru") return ru_file_count_one(inputs)
	if (locale === "es") return es_file_count_one(inputs)
	if (locale === "zh-CN") return zh_cn2_file_count_one(inputs)
	if (locale === "ja") return ja_file_count_one(inputs)
	if (locale === "hi") return hi_file_count_one(inputs)
	if (locale === "pt-PT") return pt_pt2_file_count_one(inputs)
	return en_file_count_one(inputs)
});